export * from './src/IntercomBrowserClient'
        import * as me from '@peachy/intercom-browser-client'
        
        Object.entries(me).forEach(([exportedAs, exported]) => {
            if (exported && Object.isExtensible(exported)) {
                exported[Symbol.for('__WORKSPACE_HOME')] = '/Users/dan-parker/workspace/peachy-repo/comp-kit/intercom/browser-client'
                exported[Symbol.for('__WORKSPACE_NAME')] = '@peachy/intercom-browser-client'
                exported[Symbol.for('__EXPORTED_AS')] = exportedAs
            }
        })
    